import { render, staticRenderFns } from "./OtsInsightsResults.vue?vue&type=template&id=2db6fd70&scoped=true"
import script from "./OtsInsightsResults.vue?vue&type=script&lang=js"
export * from "./OtsInsightsResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db6fd70",
  null
  
)

export default component.exports